export default "/images/logo.png?7e1f85e27d88e528af46c117809239c1";